/**
 * People API — current user profile and preferences
 */

import { peopleCoreApi } from "./client";
import type { PatchUserMeBody, PatchUserPreferencesBody, UserMe, UserPreferences } from "./types/preferences";

export async function fetchMe(): Promise<UserMe> {
  return peopleCoreApi.get<UserMe>("/users/me/");
}

export async function patchMe(body: PatchUserMeBody): Promise<UserMe> {
  return peopleCoreApi.patch<UserMe>("/users/me/", body);
}

export async function fetchPreferences(): Promise<UserPreferences> {
  return peopleCoreApi.get<UserPreferences>("/users/me/preferences/");
}

export async function patchPreferences(body: PatchUserPreferencesBody): Promise<UserPreferences> {
  return peopleCoreApi.patch<UserPreferences>("/users/me/preferences/", body);
}
